import {
	Component,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	SimpleChanges,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { ActivatedRoute, Router } from '@angular/router'
import {
	spWalletFilter,
	spWalletList,
} from 'src/app/modules/wallet/models/wallet.models'
import { WalletService } from '../../services/wallet.service'
import { TranslateService } from '@ngx-translate/core'
import { ShowReasonPopupComponent } from 'src/app/modules/clients/components/show-reason-popup/show-reason-popup.component'
import { MatDialog } from '@angular/material/dialog'

@Component({
	selector: 'app-wallet-history-list',
	templateUrl: './wallet-history-list.component.html',
	styleUrls: ['./wallet-history-list.component.scss'],
})
export class WalletHistoryListComponent
	implements OnInit, OnDestroy, OnChanges
{
	@Input() refresh: boolean = false
	subscription = new Subscription()
	walletFilter: spWalletFilter = {
		paging: {
			pageNumber: 1,
			pageSize: 10,
		},
		searchText: '',
		branchId: 0,
		startDate: null,
		endDate: null,
		transactionType: null,
		isPending: false,
	}
	filterCount: number = 0
	walletHistoryList!: spWalletList[]
	totalCount: number = 0

	constructor(
		private WalletService: WalletService,
		private ActivatedRoute: ActivatedRoute,
		public translate: TranslateService,
		private router: Router,
		private dialog: MatDialog
	) {}

	ngOnInit(): void {
		this.walletFilter.branchId = this.ActivatedRoute.snapshot.params.id
		this.subscription.add(
			this.ActivatedRoute.queryParams.subscribe((res) => {
				this.walletFilter.paging.pageNumber = res['page'] || 1
				this.walletFilter.paging.pageSize = res['count'] || 10
				this.getWalletHistoryList()
			})
		)
	}
	ngOnChanges(changes: SimpleChanges): void {
		this.getWalletHistoryList()
	}

	getWalletHistoryList(filter: any = null) {
		filter ? (this.walletFilter = { ...this.walletFilter, ...filter }) : null
		this.subscription.add(
			this.WalletService.getSpWalletTransactionList(
				this.walletFilter
			).subscribe((res: any) => {
				this.totalCount = res.result.totalCount
				this.walletHistoryList = res.result.items
			})
		)
	}
	pagingChanged(pageNumber: number, pagecount: number) {
		this.router.navigate(
			[`/layout/wallet/sp-wallet/${this.walletFilter.branchId}`],
			{
				queryParams: {
					spId: this.walletFilter.branchId,

					page: pageNumber,
					count: pagecount,
				},
			}
		)

		this.getWalletHistoryList()
	}

	viewReason(spWalletData:spWalletList){
		this.dialog
		.open(ShowReasonPopupComponent, {
			width: '550px',
			height:'350px',
			data: {
				image: spWalletData?.transactionType == 6 ? `assets/images/wallet-minus.svg` : `assets/images/empty-wallet-add.svg`,
				reason: spWalletData?.reason,
				status:spWalletData?.transactionType == 6 ? 'subtract':'add',
				availability:spWalletData?.showToClient ? 'VISIBLE_AT_SP' :'SHOWN_TO_ADMIN'

			},
		})
		.afterClosed()
		.subscribe({
			next: (res) => {
			
			},
		})
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
